import { CoreErrorDetails } from '../error-handler.backend-types'
import { TFunction } from 'i18next'

export function getBadParameterMessage(t: TFunction, details?: CoreErrorDetails<'BAD_PARAMETER'>): string | null {
  if (!details?.key) {
    return null
  }

  const message = t('pms.core_error.bad_parameter', { key: details.key })

  return message
}
